import styled from 'styled-components';

export const ExpressionLine = styled.div`
    margin-top: 10px;
    display: flex;
}
`;

export const DeleteButtonArea = styled.div`
margin-left: 5px;
}
`;

export const AddButtonArea = styled.div`
margin-top: 10px;
}
`;
